let formatter = new Intl.NumberFormat("ru", {
  maximumFractionDigits: 2
})

export function parseMoney(amount) {
    if (amount === null || amount === undefined || amount === '') {
        return formatter.format(0)
    }
    const num = typeof amount === 'number'
        ? amount
        : Number(String(amount).replace(/\s/g, '').replace(/,/g, '.'))
    if (Number.isNaN(num)) {
        return formatter.format(0)
    }
    return formatter.format(num)
}

export function strToFloatMoney(s) {
    return parseFloat(s.replace(/\s/g, '').replace(/,/g, '.'))
}